import { useState } from 'react';
import { cn } from '@shared/utils';
import { type AddressData, AddressType } from '@shared/api';
import { ChangeAddressModal } from './changeAddressModal';
import { ConfirmModal } from '@widgets';
import { Button, Text } from '@shared/widgets';
import ConfirmIcon from '@assets/icons/confirm.svg';

interface AddressItemProps {
  className?: string;
  type: AddressType;
  address: AddressData | null;
}

export const AddressItem = (props: AddressItemProps) => {
  const [showChangeAddressModal, setShowChangeAddressModal] = useState<boolean>(false);
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);

  const address = [
    { title: 'Street 1', value: props.address?.street1 || '-' },
    { title: 'Street 2', value: props.address?.street2 || '-' },
    { title: 'Postal Code', value: props.address?.postalCode || '-' },
    { title: 'City', value: props.address?.city || '-' },
    { title: 'Country', value: props.address?.country || '-' },
    { title: 'Full Address', value: props.address?.fullAddress || '-' },
  ];
  return (
    <div className={cn('flex flex-col gap-4', props.className)}>
      <Text weight='semibold' size='lg'>
        {props.address?.type} Address
      </Text>
      <ul className='space-y-2'>
        {address.map((item, idx) => (
          <li key={idx} className='flex flex-col'>
            <Text weight='semibold'>{item.title}</Text>
            <Text>{item.value}</Text>
          </li>
        ))}
      </ul>
      <Button className='w-fit' color='outlined' onClick={() => setShowChangeAddressModal(true)}>
        Change Address
      </Button>
      <ChangeAddressModal
        type={props.type}
        isOpen={showChangeAddressModal}
        onClose={() => setShowChangeAddressModal(false)}
        address={props.address}
        onSubmit={() => setShowConfirmModal(true)}
      />
      <ConfirmModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        icon={<ConfirmIcon />}
        title={`Change ${props.type} Address`}
        description='Thank you for submitting address change request. One of our key account managers will contact you shortly'
        buttonTitle='Back to the Profile page'
        onClick={() => setShowConfirmModal(false)}
      />
    </div>
  );
};
